import React, { useCallback, useEffect, useRef, useState } from 'react'
import { ReactComponent as RedDiamond } from '../../../lib/assets/red_diamond.svg'
import { ReactComponent as RedDiamondNoBorder } from '../../../lib/assets/red_diamond_noborder.svg'
import { ReactComponent as BlueDiamondNoBorder } from '../../../lib/assets/blue_diamond_noborder.svg'
import { ReactComponent as BlueDiamond } from '../../../lib/assets/blue_diamond.svg'
interface AudioProps {
  title: string
  volume: string
  setVolume: any
  mute: boolean
  setMute: any
  socketValue: any
  focusHandler: any
}
export default function VolumeBar({
  title,
  setVolume,
  volume,
  mute,
  setMute,
  socketValue,
  focusHandler,
}: AudioProps) {
  const [value, setValue] = useState<string>(volume)
  const [socketVal, setsocketVal] = useState<string>('0')
  const [focus, setFocus] = useState<boolean>(false)
  const [isFirstRun, setFirstRun] = useState(true)
  const track = useRef<any>(null)

  //TODO გადასახედია
  // useEffect(() => {
  //   setsocketVal(socketValue)
  //   setValue(socketValue)
  //   !mute && handleChange(socketVal)
  // }, [socketVal])

  useEffect(() => {
    setsocketVal(socketValue)
    setValue(socketValue)
    !mute && handleChange(socketValue)
  }, [socketValue, socketVal])

  const handleChange = (e: any) => {
    const val = e && e.target ? e.target.value : e
    setValue(val)
    setVolume(val)
    trackHandler(val)
    setFocus(true)
    Number(val) === 0 ? setMute(true) : setMute(false)
  }

  const trackHandler = (value: any) => {
    const track = document.getElementById(`track-inner-${title}`)
    const trackOut = document.getElementById(`track-outter-${title}`)
    const thumb = document.getElementById(`thumb-${title}`)
    if (track && trackOut && thumb) {
      track.style.width = `${Number(value)}%`
      trackOut.style.width = 100 - Number(track.style.width.slice(0, -1)) + '%'
      Number(value) <= 5
        ? (thumb.style.left = '4%')
        : Number(value) >= 95
        ? (thumb.style.left = '96%')
        : (thumb.style.left = value + '%')
    }
  }
  useEffect(() => {
    if (mute && Number(volume) > 0) {
      setVolume('0')
      trackHandler('0')
    } else if (!mute && Number(value) === 0) {
      setVolume('50')
      trackHandler('50')
    } else {
      setVolume(value)
      trackHandler(value)
    }
  }, [mute])

  useEffect(() => {
    !isFirstRun && focusHandler(focus)
  }, [focus])

  const focusTrue = () => {
    setFocus(true)
    setFirstRun(false)
  }

  return (
    <>
      <input
        type={'range'}
        min={0}
        max={100}
        step={1}
        value={volume}
        onChange={e => handleChange(e)}
        onTouchStart={() => focusTrue()}
        onMouseDown={() => focusTrue()}
        onMouseUp={() => setFocus(false)}
        onTouchEnd={() => setFocus(false)}
      />
      <div className='track' ref={track}>
        <div className='track-inner' id={`track-inner-${title}`}></div>
        <div className='thumb' id={`thumb-${title}`}>
          {title === 'music' ? (
            focus ? (
              <BlueDiamond />
            ) : (
              <BlueDiamondNoBorder />
            )
          ) : focus ? (
            <RedDiamond />
          ) : (
            <RedDiamondNoBorder />
          )}
        </div>
        <div className='track-outter' id={`track-outter-${title}`}></div>
      </div>
    </>
  )
}
